import React, { useState } from 'react'
import property1 from '../imgs/property1.jpg';
import BathtubOutlinedIcon from '@mui/icons-material/BathtubOutlined';
import BedOutlinedIcon from '@mui/icons-material/BedOutlined';
import RoundedCornerOutlinedIcon from '@mui/icons-material/RoundedCornerOutlined';
import { useNavigate } from 'react-router-dom';
import './info.css';
import room1 from '../imgs/room1.png';
import room2 from '../imgs/room2.jpg';
import room3 from '../imgs/room3.png';
import rooms from '../imgs/rooms.jpg';
import PhotoSizeSelectActualOutlinedIcon from '@mui/icons-material/PhotoSizeSelectActualOutlined';
import agent from '../imgs/agent.jpg';
import MailOutlineOutlinedIcon from '@mui/icons-material/MailOutlineOutlined';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import StarRoundedIcon from '@mui/icons-material/StarRounded';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import ReplyIcon from '@mui/icons-material/Reply';
import FavoriteRoundedIcon from '@mui/icons-material/FavoriteRounded';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import Roofing from '@mui/icons-material/Roofing';
import Nav from '../Nav/Nav';
import ThumbUpAltOutlinedIcon from '@mui/icons-material/ThumbUpAltOutlined';
import face2 from '../imgs/face2.jpg';
import face4 from '../imgs/face4.jpg';

const Info = () => {
    const navigate=useNavigate();
    var[photo,setPhoto]=useState(room2);

    function GoToChat(){
        navigate('/chat');
    }

  return (
    <div>
    <Nav/>

    <div className='Info'>
        <div className="InfoLeft">
            <div className="InfoLeftUp">
                <div className="InfoLeftUp1">
                    <img src={room2} alt=""  className="SmallImg1" onClick={()=>{setPhoto(room2);}}/>
                    <img src={room1} alt="" className="SmallImg1"  onClick={()=>setPhoto(room1)}/>
                    <img src={room3} alt=""  className="SmallImg1" onClick={()=>setPhoto(room3)}/>
                    <div className="moreImgs"><PhotoSizeSelectActualOutlinedIcon/>14</div>
                </div>
                <div className="InfoLeftUp2">
                    <img src={photo} alt=""  className="MainImg"/>
                    <div className="ImgNum">1/14</div>
                </div>
                <div className="InfoLeftUp3">
                    <div className="AgentInfo">
                        <button className="agent3Dots"><MoreHorizIcon style={{color:"grey"}}/></button>
                        <img src={agent} alt="" className="AgentImg" />
                        <div className="AgentName">Ava Magnuss</div>
                        <div className="AgentRating"><StarRoundedIcon style={{color:"#ffe700",fontSize:"medium"}}/> 4.9/5 (123)</div>
                        <div className="AgentNo">543 *** *** <a href="#">Show number</a></div>
                        <div className="AgentHistory">2 properties</div>

                    </div>
                    <div className="ButtonsAgent">
                        <button className="ContactAgent" onClick={GoToChat}><MailOutlineOutlinedIcon/>Contact Seller</button><br/>
                        <button className="FindAgent"><SearchOutlinedIcon/>Find other Seller</button>
                    </div>
                </div>
            </div>
            <div className="InfoLeftDown">
                <div className="InfoLeftDown1">
                    <div className="PriceMain">$400,500</div>
                    <div className="OriginalPriceMain">$406,500<InfoOutlinedIcon style={{color:"royalblue"}}/></div>
                </div>
                <div className="InfoLeftDown2">
                    <div className="NameProp">
                        Kohinoor Apartment 
                        <div className="buttonInfoLeftDown2List">
                            <button className="buttonInfoLeftDown2"><ReplyIcon/></button>
                            <button className="buttonInfoLeftDown2"><FavoriteRoundedIcon style={{color:"#ff0000b8"}}/></button>
                            <button className="buttonInfoLeftDown2"><MoreHorizIcon/></button>
                        </div>
                    </div>
                    <div className="AddressProp">329 Kohinoor St. Andheri, Mum</div><br/><br/><br/>
                    <div className="BuyHome">                
                        <button className="BuyHomeButton" onClick={GoToChat}><Roofing style={{marginRight:"4%"}}/>Buy House</button><br/>
                    </div>
                    <div className="FeaturesProp">
                        <div className="feature1">
                            <div className="featureTitle">Bedroom</div>
                            <div className="featureContent">4<BedOutlinedIcon style={{color:"grey"}}/></div>
                        </div>
                        <div className="feature2">
                            <div className="featureTitle">Bathroom</div>
                            <div className="featureContent">2<BathtubOutlinedIcon style={{color:"grey"}}/></div>
                        </div>
                        <div className="feature3">
                            <div className="featureTitle">Sq Ft.</div>
                            <div className="featureContent">4000<RoundedCornerOutlinedIcon style={{color:"grey"}}/></div>
                        </div>
                        <div className="feature4">
                            <div className="featureTitle">Built</div>
                            <div className="featureContent">2016</div>
                        </div>
                        <div className="feature5">
                            <div className="featureTitle">Parking</div>
                            <div className="featureContent">Yes</div>
                        </div>
                        <div className="feature6">
                            <div className="featureTitle">Area Safety</div>
                            <div className="featureContent">High</div>
                        </div>
                        <div className="feature4">
                            <div className="featureTitle">Listed</div>
                            <div className="featureContent">2 wks</div>
                        </div>
                        <div className="feature5">
                            <div className="featureTitle">Lease Type</div>
                            <div className="featureContent">Family</div>
                        </div>
                        <div className="feature6">
                            <div className="featureTitle">Hospital</div>
                            <div className="featureContent">3kms</div>
                        </div>
                    </div>
                </div>
                <div className="InfoLeftDown3">
                <div className="DescriptionTitle">Description</div>
                        <div className="DescriptionContent">
                            A one of a kind duplex condo boasting a multilevel patio and direct East River and roosvelt island views, this award-winning 3 bedroom.5 bathroom home is a pargon of contemporary city luxury<br/>
                            <a href="#">Show more</a>
                        </div>
                </div>
            </div>

            <div className="Feedback">
                <div className="FeedbackTitle">
                    Reviews {'  '}(20) {'   '}
                    <StarRoundedIcon className='star'/>
                    <StarRoundedIcon className='star'/>
                    <StarRoundedIcon className='star'/>
                    <StarRoundedIcon className='star'/>
                </div>
                <div className="Feedbacks">
                    <div className="Person">
                        <img src={face2} alt="" />
                        Annie S
                    </div>
                    <div className="FeedbackContent">
                        She is very friendly and accomodating.Her apartments are spacious and well furnished. Simply Perfect.
                        <div className="dateFeedback">September 2019</div>
                    </div>
                    <div className="FeedBackHelpful">
                        <ThumbUpAltOutlinedIcon className='thumb'/> <span className='HelpfulWord'>Helpful</span> (1)</div>
                </div>

                <div className="Feedbacks">
                    <div className="Person">
                        <img src={face4} alt="" />
                        Henry S
                    </div>
                    <div className="FeedbackContent">
                        Her apartments are spacious and well furnished. Simply Perfect.
                        <div className="dateFeedback">June 2019</div>
                    </div>
                    <div className="FeedBackHelpful">
                        <ThumbUpAltOutlinedIcon className='thumb'/> <span className='HelpfulWord'>Helpful</span> (3)</div>
                </div><br/><br/>
                <a href="#" style={{"margin":"5%"}}>More reviews</a><br/><br/>
            </div>
        </div>

        <div className="InfoRight">
          <div className='googleMaps' id="map">
              <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d942.2468374729383!2d72.82852007847538!3d19.15203101575131!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7b6403214901f%3A0x837e8956dd36219f!2sAPARTMENT%20KOHINOOR%2C%20Milat%20Nagar%2C%20Andheri%20West%2C%20Mumbai%2C%20Maharashtra%20400047!5e0!3m2!1sen!2sin!4v1687614190377!5m2!1sen!2sin" height="450"  allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>
           </div>
        </div>
    </div>
   </div>

  )
}

export default Info